import { safeNormalize } from '../../../utils';
var LETTER_TO_PROP_NAME = {
  D: 'day',
  M: 'month',
  Y: 'year'
};

var getDateOfBirthOrder = (datePattern, separator) => {
  var formatComponents = datePattern.toUpperCase().split(separator).map(str => str.trim());
  var dayIdx = formatComponents.indexOf('DD');
  var monthIdx = formatComponents.indexOf('MM');

  if (dayIdx === 0 && monthIdx === 1) {
    return 'DMY';
  } else if (dayIdx === 1 && monthIdx === 0) {
    return 'MDY';
  }

  return 'YMD';
};

var getDateOfBirthSeparator = datePattern => {
  var matchArr = datePattern.match(/[-./]/);
  return (matchArr === null || matchArr === void 0 ? void 0 : matchArr[0]) || '';
};

var parseByDateOfBirthSeparator = (dateOrder, dobInput, separator) => {
  var inputComponents = dobInput.split(separator);
  var dateOfBirth = {};
  var first = inputComponents[0];
  var sec = inputComponents[1] || '';
  var third = inputComponents[2] || '';
  dateOfBirth.inputValue = dobInput;

  if (dateOrder === 'DMY') {
    dateOfBirth.day = first;
    dateOfBirth.month = sec;
    dateOfBirth.year = third;
  } else if (dateOrder === 'YMD') {
    dateOfBirth.year = first;
    dateOfBirth.month = sec;
    dateOfBirth.day = third;
  } else {
    dateOfBirth.month = first;
    dateOfBirth.day = sec;
    dateOfBirth.year = third;
  }

  return dateOfBirth;
};

var replaceDateOfBirthNonDigits = (value, separator) => {
  var numNonDigitGroups = 0;
  var normalizedValue = safeNormalize(value);
  return normalizedValue.replace(/\D+/g, (match, foundAtIdx) => {
    var shouldRemove = foundAtIdx === 0 || ++numNonDigitGroups > 2;
    return shouldRemove ? '' : separator;
  });
};

var autoFormatDateOfBirth = (dateInput, dateOrder) => {
  var isRoughlyValid = {
    day: d => ('' + d).length <= 2 && d <= 31,
    month: m => ('' + m).length <= 2 && m <= 12,
    year: y => ('' + y).length <= 4
  };
  var formattedDate = {};
  var nextProp;

  for (var i = 0; i < 2; i++) {
    var dateUnitLetter = dateOrder[i];
    var dateUnit = LETTER_TO_PROP_NAME[dateUnitLetter];
    var overflowStart = 1;
    var overflow = dateInput[dateUnit].substr(1);
    formattedDate[dateUnit] = dateInput[dateUnit][0] ? dateInput[dateUnit][0] : '';

    while (overflow.length !== 0 && isRoughlyValid[dateUnit](formattedDate[dateUnit] + overflow[0])) {
      formattedDate[dateUnit] += dateInput[dateUnit][overflowStart];
      overflow = overflow.substr(1);
      overflowStart++;
    }

    var nextPropLetter = dateOrder[i + 1];
    nextProp = LETTER_TO_PROP_NAME[nextPropLetter];
    dateInput[nextProp] = overflow + dateInput[nextProp];
  }

  var lastUnit = '';

  for (var j = 0; j < dateInput[nextProp].length; j++) {
    var digit = dateInput[nextProp][j];

    if (isRoughlyValid[nextProp](lastUnit + digit)) {
      lastUnit += digit;
    }
  }

  formattedDate[nextProp] = lastUnit;
  formattedDate.inputValue = dateInput.inputValue;
  return formattedDate;
};

var dateOfBirthToString = (date, dateOrder, separator) => {
  var firstUnit = date[LETTER_TO_PROP_NAME[dateOrder[0]]],
      secUnit = date[LETTER_TO_PROP_NAME[dateOrder[1]]],
      thirdUnit = date[LETTER_TO_PROP_NAME[dateOrder[2]]];
  var result = firstUnit;

  if (secUnit.length !== 0) {
    result += separator + secUnit;
  }

  if (thirdUnit.length !== 0) {
    result += separator + thirdUnit;
  }

  var hasLessThanTwoSeparators = result.split(separator).length < 3;

  if (hasLessThanTwoSeparators && date.inputValue.substr(-1) === separator) {
    result += separator;
  }

  return result;
};

var inputToFormattedDateOfBirth = (input, datePattern) => {
  var separator = getDateOfBirthSeparator(datePattern);
  var dateOrder = getDateOfBirthOrder(datePattern, separator);
  var formattedInput = replaceDateOfBirthNonDigits(input, separator);
  var parsedInput = parseByDateOfBirthSeparator(dateOrder, formattedInput, separator);
  var formattedDate = autoFormatDateOfBirth(parsedInput, dateOrder);
  var newValue = dateOfBirthToString(formattedDate, dateOrder, separator);
  return {
    formattedDate,
    newValue
  };
};

export { inputToFormattedDateOfBirth, getDateOfBirthOrder, getDateOfBirthSeparator, parseByDateOfBirthSeparator, autoFormatDateOfBirth, dateOfBirthToString, replaceDateOfBirthNonDigits };